import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewSecurityFinishedModel, AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface } from '../models';

import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import {
  AllocationViewFinishArrivalSecurityAction,
  AllocationViewFinishArrivalSecurityActionPrepare,
  AllocationViewFinishArrivalSecurityActionSetInitialState,
} from './allocation-view-finish-arrival-security-action.actions';

import { AllocationViewFinishArrivalSecurityActionState } from './allocation-view-finish-arrival-security-action.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewFinishArrivalSecurityActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewFinishArrivalSecurityActionState.getLoaded);
  arrivalSecurityFinishPrepareData$: Observable<AllocationViewSecurityFinishedModel> = this.store.select(
    AllocationViewFinishArrivalSecurityActionState.getArrivalSecurityFinishPrepareData,
  );

  constructor(
    private allocationViewActionsFacade: AllocationViewActionsFacade,
    private translateService: TranslateService,
    private store: Store,
  ) {}

  loadAll(): void {
    this.store.dispatch(new AllocationViewFinishArrivalSecurityActionSetInitialState());
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewFinishArrivalSecurityActionPrepare(identifier, this.translateService.currentLang),
        );
      });
  }

  arrivalSecurityFinish(data: AllocationViewSecurityFinishedModel): void {
    this.allocationViewActionsFacade.actionIdentifier$.pipe(filter(Boolean), take(1)).subscribe(() => {
      this.store.dispatch(new AllocationViewFinishArrivalSecurityAction(data));
    });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewFinishArrivalSecurityActionSetInitialState());
  }
}
